import { render, staticRenderFns } from "./add-node-overlay.vue?vue&type=template&id=fc2f6168&scoped=true&"
import script from "./add-node-overlay.vue?vue&type=script&lang=ts&"
export * from "./add-node-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./add-node-overlay.vue?vue&type=style&index=0&id=fc2f6168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2f6168",
  null
  
)

export default component.exports